export default "__VITE_ASSET__5cc8d070__"